import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "flex flex-wrap gap-x-component-x-spacing-xs lg:gap-x-component-x-spacing-md gap-3",
    heading: "px-component-x-spacing-xs text-heading-2xs",
    linksWrapper: "flex justify-start gap-2 overflow-x-auto overflow-y-visible py-1",
    link: ""
  },
  variants: {
    layout: {
      "space-between": {
        base: "flex flex-row justify-between items-center",
        linksWrapper: "w-auto",
        heading: "w-auto"
      },
      column: {
        base: "flex flex-col justify-start items-start",
        heading: "w-full",
        linksWrapper: "w-full"
      },
      scroll: {
        linksWrapper: "flex gap-2 *:shrink-0 snap-mandatory scroll-px-[--spacing-x] px-[--spacing-x] -mx-[--spacing-x] snap-x overflow-x-scroll overflow-y-visible box-border",
        link: "snap-start"
      },
      grid: {
        base: "flex flex-col",
        linksWrapper: "grid grid-cols-2 md:grid-cols-6 w-full",
        heading: "",
        link: "col-span-1 flex justify-center items-center"
      }
    }
  },
  defaultVariants: {
    layout: {
      initial: "scroll",
      lg: "space-between"
    }
  }
});
export {
  a as linkShortcutsBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
